<template>
  <div class="cost-estimator text-center">
    <h3 class="font-italic mb-2">Your Cost Estimator</h3>
    <h4 class="display-2 font-weight-bold mb-2">{{ formatUSD(totalCost) }}</h4>
    <div class="body-1 font-weight-bold grey--text"
      >$7 + ${{ this.revShare }} (1%)
    </div>
    <v-slider
      min="0"
      max="5000"
      step="250"
      hide-details
      v-model="monthlySales"
      dense
    >
      <template v-slot:prepend><span class="mt-1">$0</span></template>
      <template v-slot:append><span class="mt-1">$5k</span></template>
      <template v-slot:message="{ message }"
        ><div class="text-center">{{ message }}</div></template
      >
    </v-slider>
    <div class="headline font-weight-bold"
      >{{ formatUSD(monthlySales) }} sold</div
    >
  </div>
</template>

<script>
export default {
  name: 'CostEstimator',
  components: {},
  computed: {
    revShare() {
      return Math.floor(this.monthlySales * 0.01)
    }, // revShare
    totalCost() {
      return this.basePrice + this.revShare
    }, // totalCost
  },
  data() {
    return {
      basePrice: 7,
      monthlySales: 250,
    }
  },
  methods: {
    formatUSD(val) {
      // Create our number formatter.
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',

        // These options are needed to round to whole numbers if that's what you want.
        minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      })

      return formatter.format(val) /* $2,500.00 */
    },
  },
}
</script>
